import React from 'react';
import Title from '../miscellaneous/Title';
import SortedTable from "../miscellaneous/SortedTable";
import {
    bestBoundWithTimeLimit,
    computeBestBoundWithTimeLimit,
    is_unsat,
    isFiltered
} from "../miscellaneous/functionsCOP";

let nbBenchmarks = 0

function initData(name) {
    return {solver: name, score: 0, opt: 0, bb1: 0, bb2: 0, unsat: 0, unsupported: 0}
}


function createResults(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];
    let mapy = new Map()
    nbBenchmarks = 0
    mapy.set(0, initData("<i>Virtual Best Solver</i>"))

    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []

    for (let s of selectedSolvers) {
        let current = initData(s.name + " " + s.version)
        const d = data[s.id]
        for (let result of d) {
            if (result === undefined || isFiltered(filters, result) === false)
                continue;
            if(result.bug === 0 && result.time < filters.timeLimit && is_unsat(result)) {
                current.unsat++
                continue
            }
            if (result.bug === 0 && result.time !== -1 && result.time < filters.timeLimit)
                current.opt++

        }
        mapy.set(s.id, current)
    }

    for (let i = 0; i < benchmarks.length; i++) {
        let b = benchmarks[i]
        if(isFiltered(filters, b) === false)
            continue
        nbBenchmarks++

        let foundOpt = false
        let foundBest = false
        let unsupported = true
        let [best, optim, unsat] = computeBestBoundWithTimeLimit(b, selectedSolvers, data, filters, i, filters.timeLimit)
        if(unsat)
            mapy.get(0).unsat++
        else
           if(optim)
                mapy.get(0).opt++


        //if (best === false) continue // no bounds known
        for (let s of selectedSolvers) { // Find best score

            const result = data[s.id][i]
            if (result === undefined || result.bug === 1)
                continue

            if(result.unsupported === 1) {
                mapy.get(s.id).unsupported++
                continue
            }  else unsupported = false


            let bound = bestBoundWithTimeLimit(result.bounds, filters.timeLimit)

            if(bound.bound === best) {
                if (optim === false && bound.bound === best) {
                    if(foundBest === false) { // Best form VBS
                        foundBest = true
                        mapy.get(0).bb1++
                    }
                    mapy.get(s.id).bb1++
                }
                if (optim === true && bound.bound === best && (result.time === -1 || result.time >= filters.timeLimit))
                    mapy.get(s.id).bb2++
            }
        }
        if(unsupported)
            mapy.get(0).unsupported++
    }
    mapy.forEach(v => tmp.push(v))
    return tmp;
}


export default function Summary(props) {


    if (props.selectedSolvers.length === 0) return null;
    if(props.filters.name == null)
        return null;
    let rows = createResults(props.selectedSolvers, props.results, props.benchmarks, props.filters)
    if (rows.length === 0) return null;
    for(let res of rows) {
        //if(res.solver === "<i>Virtual Best Solver</i>")
        //    continue
        res.score = res.opt + res.unsat + res.bb1 + res.bb2/2
        res.score = parseFloat((res.score*100)/100).toFixed(2)
    }

    // Score For VBS
    //rows[0].score =
    //rows[0].score = parseFloat((rows[0].score*100)/100).toFixed(2)
    rows[0].classes = "vbs"

    const headCells = [
        {id: 'solver', numeric: false, disablePadding: true, label: 'Solver'},
        {id: 'score', numeric: true, disablePadding: false, label: "Score"},
        {id: 'opt', numeric: true, disablePadding: false, label: "#Opt"},
        {id: 'bb1', numeric: true, disablePadding: false, label: "#BB1"},
        {id: 'bb2', numeric: true, disablePadding: false, label: "#BB2"},
        {id: "unsat", numeric: true, disablePadding: false, label: "#Unsat"},
        {id: 'unsupported', numeric: true, disablePadding: false, label: "#Unsupported"},
    ];

    return (
        <React.Fragment>
            <Title><span style={{color:'#408033'}}>Ranking of Solvers</span></Title>
            <strong>Nb selected instances: {nbBenchmarks} </strong>
            <SortedTable rows={rows} headCells={headCells} order='score' asc={'desc'}/>
        </React.Fragment>
    )
}